import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BomDetailsComponent } from '../dialog/bom-details/bom-details.component';
import { MatDialog } from '@angular/material/dialog';
import { SchedulerItem } from '../../common/scheduler/models/item';

@Injectable({
  providedIn: 'root',
})
export abstract class SingleDepartmentService {
  protected readonly router = inject(Router);
  protected readonly dialog = inject(MatDialog);

  readonly NAME: string = '';
  readonly DEPARTMENT_ID: number = undefined;
  readonly BRAND: 'sb' | 'daystar' = 'sb';

  onClick(appShowBomDialog: SchedulerItem): void {
    this.dialog.open(BomDetailsComponent, {
      data: {
        searching: appShowBomDialog.workOrderId,
        query: 'destination=true',
      },
    });
  }

  abstract defaultRoutes(roles: string[]): boolean;
}
